import {
  BlessingResponse,
  CreateGiftCardsOrderModel,
  CreateGroupPurchaseRequest,
} from "api"
import {
  Dispatch,
  FC,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from "react"
import * as McDonalds from "../../api/generated/McDonaldsInterfaces"

export type QuickPurchaseDataType = {
  amount: string
  RecipientName: string
  RecipientMobilePhone: string
  RecipientEmail: string
  SenderName: string
  SenderLastName: string
  SenderMobilePhone: string
  SenderEmail: string
}

export type QuickPurchaseContextType = {
  purchaseData: CreateGiftCardsOrderModel
  setPurchaseData: Dispatch<SetStateAction<{}>>
  selectedGiftCard: BlessingResponse
  setSelectedGiftCard: Dispatch<SetStateAction<{}>>
  blessingMode: string
  setBlessingMode: Dispatch<SetStateAction<string>>
  giftCardPrice: number
  setGiftCardPrice: Dispatch<SetStateAction<number>>
  priceAfterDiscount: number
  setPriceAfterDiscount: Dispatch<SetStateAction<number>>
  orderId: number
  giftCardLoadAmount: number
  setGiftCardLoadAmount: Dispatch<SetStateAction<number>>
  setOrderId: Dispatch<SetStateAction<number>>
  otherAmount: boolean
  setOtherAmount: Dispatch<SetStateAction<boolean>>
  promotion: string
  setPromotion: Dispatch<SetStateAction<string>>
  setCategoryName: Dispatch<SetStateAction<string>>
  categoryName: string
  orderRecipientGuid: string
  setOrderRecipientGuid: Dispatch<SetStateAction<string>>
  groupPurchaseData: CreateGroupPurchaseRequest
  setGroupPurchaseData: Dispatch<SetStateAction<{}>>
  groupPurchaseGuid: string
  setGroupPurchaseGuid: Dispatch<SetStateAction<string>>
  groupPurchaseUserGuid: string
  setGroupPurchaseUserGuid: Dispatch<SetStateAction<string>>
  setPrevPath: Dispatch<SetStateAction<string>>
  prevPath: string
  setVideoModal: Dispatch<SetStateAction<boolean>>
  videoModal: boolean
  videoFile: File
  setVideoFile: Dispatch<SetStateAction<File>>
  setVideoRatio: Dispatch<SetStateAction<String>>
  videoRatio: string
  setIsVideoApproved: Dispatch<SetStateAction<boolean>>
  isVideoApproved: boolean
  setTransactionSerialId: Dispatch<SetStateAction<string>>
  setPaymentInitiationId: Dispatch<SetStateAction<string>>
  transactionSerialId: string
  paymentInitiationId: string
  setSchedulerType: Dispatch<SetStateAction<string>>
  schedulerType: string
  setOrderTotal: Dispatch<SetStateAction<number>>
  orderTotal: number
  setAddPercentage: Dispatch<SetStateAction<number>>
  addPercentage: number
  discount: number
  setDiscount: Dispatch<SetStateAction<number>>
  validationPassed: boolean
  setValidationPassed: Dispatch<SetStateAction<boolean>>
  showStickyBottom: boolean
  setshowStickyBottom: Dispatch<SetStateAction<boolean>>
  submitFormTrigger: any
  setSubmitFormTrigger: any
  quickPurchaseInputValues: any
  setQuickPurchaseInputValues: any
  showExitModal: boolean
  setShowExitModal: Dispatch<SetStateAction<boolean>>
  canProceed: boolean
  setCanProceed: Dispatch<SetStateAction<boolean>>
  settings: McDonalds.QuickPurchaseSettingsDtoResponseWrapper
  setSettings: Dispatch<
    SetStateAction<McDonalds.QuickPurchaseSettingsDtoResponseWrapper>
  >
}

export const QuickPurchaseContext =
  createContext<QuickPurchaseContextType>(null)

export const initialState: QuickPurchaseDataType = {
  amount: "",
  RecipientName: "",
  RecipientMobilePhone: "",
  RecipientEmail: "",
  SenderName: "",
  SenderLastName: "",
  SenderMobilePhone: "",
  SenderEmail: "",
}

export const QuickPurchaseContextProvider: FC = ({ children }) => {
  const [purchaseData, setPurchaseData] = useState<CreateGiftCardsOrderModel>()
  const [selectedGiftCard, setSelectedGiftCard] = useState<BlessingResponse>()
  const [blessingMode, setBlessingMode] = useState<string>("")
  const [giftCardPrice, setGiftCardPrice] = useState<number>(0)
  const [priceAfterDiscount, setPriceAfterDiscount] = useState<number>(0)
  const [giftCardLoadAmount, setGiftCardLoadAmount] = useState<number>(0)
  const [orderId, setOrderId] = useState<number>()
  const [otherAmount, setOtherAmount] = useState<boolean>(false)
  const [promotion, setPromotion] = useState(null)
  const [categoryName, setCategoryName] = useState(null)
  const [groupPurchaseData, setGroupPurchaseData] =
    useState<CreateGroupPurchaseRequest>()
  const [orderRecipientGuid, setOrderRecipientGuid] = useState<string>()
  const [groupPurchaseGuid, setGroupPurchaseGuid] = useState<string>()
  const [groupPurchaseUserGuid, setGroupPurchaseUserGuid] = useState<string>()
  const [prevPath, setPrevPath] = useState("")
  const [videoModal, setVideoModal] = useState(false)
  const [videoFile, setVideoFile] = useState(null)
  const [videoRatio, setVideoRatio] = useState("")
  const [isVideoApproved, setIsVideoApproved] = useState(false)
  const [transactionSerialId, setTransactionSerialId] = useState("")
  const [paymentInitiationId, setPaymentInitiationId] = useState("")
  const [schedulerType, setSchedulerType] = useState(null)
  const [orderTotal, setOrderTotal] = useState<number>(0)
  const [addPercentage, setAddPercentage] = useState<number>()
  const [discount, setDiscount] = useState<number>()
  const [validationPassed, setValidationPassed] = useState(false)
  const [showStickyBottom, setshowStickyBottom] = useState(false)
  const [submitFormTrigger, setSubmitFormTrigger] = useState<any>(null)
  const [quickPurchaseInputValues, setQuickPurchaseInputValues] =
    useState<QuickPurchaseDataType>(initialState)
  const [showExitModal, setShowExitModal] = useState(false)
  const [canProceed, setCanProceed] = useState(true)
  const [settings, setSettings] = useState(null)

  return (
    <QuickPurchaseContext.Provider
      value={{
        priceAfterDiscount,
        setPriceAfterDiscount,
        settings,
        setSettings,
        canProceed,
        setCanProceed,
        showExitModal,
        setShowExitModal,
        quickPurchaseInputValues,
        setQuickPurchaseInputValues,
        submitFormTrigger,
        setSubmitFormTrigger,
        showStickyBottom,
        setshowStickyBottom,
        validationPassed,
        setValidationPassed,
        discount,
        setDiscount,
        purchaseData,
        setPurchaseData,
        selectedGiftCard,
        setSelectedGiftCard,
        blessingMode,
        setBlessingMode,
        setGiftCardPrice,
        giftCardPrice,
        orderId,
        setOrderId,
        otherAmount,
        setOtherAmount,
        giftCardLoadAmount,
        setGiftCardLoadAmount,
        promotion,
        setPromotion,
        categoryName,
        setCategoryName,
        groupPurchaseData,
        setGroupPurchaseData,
        orderRecipientGuid,
        setOrderRecipientGuid,
        groupPurchaseGuid,
        setGroupPurchaseGuid,
        groupPurchaseUserGuid,
        setGroupPurchaseUserGuid,
        setPrevPath,
        prevPath,
        setVideoModal,
        videoModal,
        videoFile,
        setVideoFile,
        setVideoRatio,
        videoRatio,
        isVideoApproved,
        setIsVideoApproved,
        paymentInitiationId,
        transactionSerialId,
        setTransactionSerialId,
        setPaymentInitiationId,
        setSchedulerType,
        schedulerType,
        orderTotal,
        setOrderTotal,
        setAddPercentage,
        addPercentage,
      }}
    >
      {children}
    </QuickPurchaseContext.Provider>
  )
}

export const useQuickPurchaseContext = () => useContext(QuickPurchaseContext)
